<div class="textbox-container">
  <label *ngIf="label" class="textbox-label">{{ label }}</label>
  <div class="textbox-box" [style.width]="width" [class.error]="hasError" [class.disabled]="disabled" [class.size-x-small]="size === 'x-small'" [class.size-small]="size === 'small'" [class.size-medium]="size === 'medium'" [class.size-large]="size === 'large'">
    <input
      type="text"
      [ngModel]="model"
      (ngModelChange)="onInput($event)"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [readonly]="readonly"
      (click)="onClick($event)"
    />
    <i
      *ngIf="showClearButton && hasValue && !disabled"
      class="fal fa-times clear-icon"
      (click)="onClear()"
      title="Clear"
    ></i>
  </div>
  <div *ngIf="hasError && errorText" class="error-text">
    <i class="fal fa-exclamation-circle error-icon"></i>
    {{ errorText }}
  </div>
</div>

